export default "__VITE_ASSET__FvU8XPIe__"